import React from 'react';
import { Sidebar } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/modules/sidebar.less';

export default Sidebar;
